import { render } from "./CountdownElement.vue?vue&type=template&id=580cda4f"
import script from "./CountdownElement.vue?vue&type=script&lang=js"
export * from "./CountdownElement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__